<main class="container p-5 min-vh-80">
  <section class="bg-white p-5 m-5">
    <h3 class="text-center">Account Activation</h3>
    <article>
      <p class="text-center">
        Thank you for registration. An activation link has been sent to your email. Please activate your account to login.
      </p>
      <p class="text-center">
        <a routerLink="/login" class="btn btn-primary">Login</a>
      </p>
    </article>
  </section>
</main>
